import React, { useEffect, useState } from "react";
import { useFirebaseConnect, isLoaded } from "react-redux-firebase";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  EntryBasic,
  Entry3D,
  EntryPixel,
  EntryDev,
  EntryWrite,
} from "./layouts/EntryLayouts";
import CONSTANTS from "../../../misc/constants";
import LogoType from "../../utils/LogoType";
import Modal from "../../utils/Modal";
import styled from "styled-components";
import DisqusComments from "../../utils/DisqusComments";

const EntryView = () => {
  const [selectedImage, setSelectedImage] = useState("");
  const [displayedLang, setDisplayedLang] = useState("esp");
  const [modalOpen, setModalOpen] = useState(false);

  const { key } = useParams();

  /**<-- Get Entry Data from firebase in edit mode */
  useFirebaseConnect([
    {
      type: "once",
      path: "blog_entries",
      queryParams: ["orderByChild=slug", `equalTo=${key}`],
    },
  ]);

  const blog_entry = useSelector(
    (store) => store.firebase.ordered.blog_entries
  );

  const langCode = useSelector((store) => store.options.lang.code);
  const profile = useSelector((store) => store.firebase.profile);


  useEffect(() => {
    document.title = `${CONSTANTS.APP_NAME} | Blog`;
    if (isLoaded(blog_entry) && blog_entry) {
      if (blog_entry[0].value.content[langCode]) {
        document.title = `${CONSTANTS.APP_NAME} | ${blog_entry[0].value.content[langCode].title}`;
        setDisplayedLang(langCode);
      } else {
        if (langCode === "esp") {
          document.title = `${CONSTANTS.APP_NAME} | ${blog_entry[0].value.content.en.title}`;
          setDisplayedLang("en");
        } else if (langCode === "en") {
          document.title = `${CONSTANTS.APP_NAME} | ${blog_entry[0].value.content.esp.title}`;
          setDisplayedLang("esp");
        }
      }
    }
  }, [setDisplayedLang, blog_entry, langCode]);

  /**Get Entry Data from firebase in edit mode -->*/

  const handleImageModal = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  let Layout = EntryBasic;
  if (isLoaded(blog_entry) && blog_entry) {
    const type = blog_entry[0].value.entryType;
    switch (type) {
      case CONSTANTS.ENTRY_TYPES.MODELING_3D: {
        Layout = Entry3D;
        break;
      }
      case CONSTANTS.ENTRY_TYPES.PIXEL_ART: {
        Layout = EntryPixel;
        break;
      }
      case CONSTANTS.ENTRY_TYPES.WEB_DEVELOPMENT:
      case CONSTANTS.ENTRY_TYPES.GAME_DEVELOPMENT: {
        Layout = EntryDev;
        break;
      }
      case CONSTANTS.ENTRY_TYPES.WRITING: {
        Layout = EntryWrite;
        break;
      }
      default: {
        break;
      }
    }
  }
  return (
    <>
      {isLoaded(blog_entry) && blog_entry && blog_entry.length === 1 && (
        <StyledEntry>
          {profile.role >= 5 && (
            <Link
              className="btn action-btn"
              to={`/edit-entry/${blog_entry[0].key}`}
            >
              <i className="fas fa-edit"></i>
            </Link>
          )}
          <div className="title">
            <h1>{blog_entry[0].value.content[displayedLang].title}</h1>
            <LogoType type={blog_entry[0].value.entryType} />
          </div>
          <hr />
          <div className="main-content">
            <Layout
              data={{
                ...blog_entry[0].value,
                content: blog_entry[0].value.content[displayedLang],
              }}
              handleImageModal={handleImageModal}
            />
          </div>
          <hr className="separator"/>
          <DisqusComments page_url={`${CONSTANTS}entry/${blog_entry[0].value.slug}`} identifier={`${blog_entry[0].key}`}/>
          <Modal open={modalOpen} toggleHandler={setModalOpen}>
            <img
              src={selectedImage}
              alt={selectedImage}
              className="gallery-full responsive-img"
            />
          </Modal>
        </StyledEntry>
      )}
    </>
  );
};

const StyledEntry = styled.div`
  .title {
    padding: 0.6rem;
    display: flex;
    justify-content: space-between;
    .logo-type {
      width: 5rem;
      height: auto;
    }
  }
  .separator{
    margin-top: 10rem;
  }
`;

export default EntryView;
